import { StandardTextFieldProps, TextField } from '@mui/material';
import { CountrySelect } from 'components/CountrySelect';
import { Country } from 'config';
import { INDEX } from 'config/fe-routes';
import { ChangeEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BusinessDac7FormField, businessStrictlyRequiredFields, IBusinessEntityData } from 'types/user.types';
import { camelToKebabCase } from 'utils/format-text';
import { redirectTo } from 'utils/route-helpers';

import { useLanguage } from '../../hooks/useLanguage';

export const BusinessAccountTypeForm = ({ data, handleData, errors }) => {
  const { t } = useTranslation();
  const { country } = useLanguage();

  const commonTextFieldProps: StandardTextFieldProps = {
    variant: 'standard',
    InputLabelProps: {
      shrink: true,
    },
    onChange: handleData,
    className: 'DAC7-form-field',
  };

  const getCustomTextFieldProps = (fieldName: keyof IBusinessEntityData) => {
    const fieldNameInKebabCase = camelToKebabCase(fieldName);

    return {
      error: errors && !!errors[fieldName],
      inputProps: {
        'data-field': fieldName,
      },
      label: t(`pages.DAC7.form.business.${fieldNameInKebabCase}`),
      value: data[fieldName] || '',
      helperText: errors && t(errors[fieldName]),
      required: businessStrictlyRequiredFields.includes(fieldName),
      placeholder: t(`pages.DAC7.form.business.placeholder-${fieldNameInKebabCase}`),
    };
  };

  useEffect(() => {
    // Only for Estonia
    if (country !== Country.EE) {
      redirectTo(INDEX());
    }
  }, []);

  return (
    <div className="DAC7-form__business-form DAC7-user-data-form">
      <h5 className="DAC7-user-data-form__title">{t('pages.DAC7.form.business.title')}</h5>
      <TextField {...commonTextFieldProps} {...getCustomTextFieldProps(BusinessDac7FormField.name)} />
      <TextField {...commonTextFieldProps} {...getCustomTextFieldProps(BusinessDac7FormField.registryCode)} />
      <TextField {...commonTextFieldProps} {...getCustomTextFieldProps(BusinessDac7FormField.registrationAddress)} />
      <CountrySelect
        classes="DAC7-form-field"
        {...getCustomTextFieldProps(BusinessDac7FormField.operatingCountry)}
        countryCode={data[BusinessDac7FormField.operatingCountry]}
        handleChange={(_, item) => handleData(_ as ChangeEvent, item?.code || '', BusinessDac7FormField.operatingCountry)}
      />
      <TextField {...commonTextFieldProps} {...getCustomTextFieldProps(BusinessDac7FormField.vat)} />
    </div>
  );
};
